import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [currentLang, setCurrentLang] = useState(() => {
    // Initialize from localStorage
    return localStorage.getItem("preferredLanguage") || "en";
  });

  const updateCurrentLang = (currentLanguage) => {
    console.log('inside updateCurrentLang--------------->', currentLanguage);
    setCurrentLang(currentLanguage); // Update state
  };

  useEffect(() => {
    
    const storedCurrentLanguage = localStorage.getItem("preferredLanguage");
    if (storedCurrentLanguage && storedCurrentLanguage !== currentLang) {
      
      setCurrentLang(storedCurrentLanguage);
    }
  }, [currentLang]);


  return (
    <AuthContext.Provider value={{ currentLang, updateCurrentLang }}>
      {children ? children : ''}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
